<template>
    <project-step-container
            prev-to="be_deep_customer_empathy_3"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row class="pb-4">
            <b-col class="text-center" cols="12">
                <img width="85%" :src="getImage" tabindex="0"
                     alt="Student interviewing another student.">
            </b-col>
            <b-col cols="12" class="mt-4 simple-text" tabindex="0">
              {{getMessage(4, 'empathy-map-sub')}}
            </b-col>
        </b-row>
        <LinkStyleGuide @open-url="openGuideCustomerInterview" icon-name="icon-guide" :text="getMessage(4, 'empathy-map-guide')" ></LinkStyleGuide>
        <br>
        <LinkStyleGuide @open-url="openGuideFollowMeHome" icon-name="icon-guide" :text="getMessage(4, 'empathy-map-guide-2')"></LinkStyleGuide>

        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
    import {ConflictSyn, Project, StyleGuides} from "../../../core/Utils";
    import {Steps} from "@/modules/BeEntrepreneurship/Utils";

    export default {
        name: "DeepCustomerEmpathy4",
        components: {ProjectStepContainer, LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_INSTRUCTIONS_CUSTOMER_EMPATHY,
                styleGuide: {}
            }
        },
        computed: {
            getImage() {
                return require("../Images/student-interviewing.jpg")
            },
        },
        methods: {
            openGuideCustomerInterview() {
                this.styleGuide = StyleGuides.getStyleGuide(StyleGuides.CUSTOMER_INTERVIEW_GUIDE)
                this.$bvModal.show('project-style-guide')
            },
            openGuideFollowMeHome() {
                this.styleGuide = StyleGuides.getStyleGuide(StyleGuides.FOLLOW_ME_HOME_GUIDE)
                this.$bvModal.show('project-style-guide')
            },
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index

                Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'be_deep_customer_empathy_5', params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
</style>
